module.exports = __webpack_public_path__ + "media/newstyle/images/icon-trash-8be7b9f808455069b41aa32364e67d39.svg";